// extracted by mini-css-extract-plugin
export default {"dependents":"dependents_dependents__j681I","addButton":"dependents_addButton__K7izE"};